<div [kalLoading]="loading">
    <div kalDialogContent [formGroup]="form" class="folderBankListDialog">

        <div class="folderBankListDialog__tools gup-C-flexGroup -row -alignCenter -justifyStart gup-o-list"
             *ngIf="shouldDisplayLocalFile else folderListTemplate">

            <app-folder-bank-add formControlName="localFile"></app-folder-bank-add>

        </div>

        <ng-template #folderListTemplate>

            <app-shared-icon-button (click)="toggleAddLocalFile()">
                Ajouter depuis mon ordinateur
            </app-shared-icon-button>

            <app-folder-bank-list formControlName="fileFromList" >
            </app-folder-bank-list>

        </ng-template>

    </div>

    <div kalDialogFooter *ngIf="!isOpenedFilters">

        <div class="gup-C-validationArea gup-O-list">

            <div class="gup-O-list__item">

                <kal-button kalTheme="primary"
                            [disabled]="form.invalid || (selectedFolder?.ListeDocumentsToSave?.FichierCompletModel | arrayEmpty) || loading"
                            (click)="submit()">
                    Ajouter
                </kal-button>

            </div>

            <div class="gup-O-list__item">

                <kal-button id="folder_bank_dialog_cancel"
                            kalTheme="secondary"
                            (click)="close()">
                    Annuler
                </kal-button>

            </div>

        </div>

    </div>

</div>
